import clsx from "clsx";
import { NotebookPenIcon } from "lucide-react";

import { useGlobalStore } from "~/hooks";

const AnnotationsButton = () => {
	const { isAnnotationsPanelOpen, toggleAnnotationsPanel } = useGlobalStore();

	return (
		<button
			data-tooltip-id="tooltip"
			data-tooltip-content="Highlights & Notes"
			onClick={toggleAnnotationsPanel}
			className={clsx(
				"relative flex h-10 w-10 cursor-pointer select-none items-center justify-center rounded-full text-2xl hover:bg-slate-100 dark:hover:bg-slate-700",
				{ "bg-slate-50 dark:bg-slate-700/50": isAnnotationsPanelOpen },
			)}
		>
			<NotebookPenIcon size={22} />
		</button>
	);
};

export default AnnotationsButton;
